module.exports = __webpack_public_path__ + "img/x-Sj.7127f830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/x-Sj.jpg
// module id = xuHr
// module chunks = 1